import { MutationTree } from 'vuex';
import { TFeedbackStore, TFeedbackQuestion, TResult, TFeedbackForm } from '../types';
import { MUTATION_TYPES } from './storeTypes';
import _cloneDeep from 'lodash.clonedeep';

export const mutations: MutationTree<TFeedbackStore> = {
  [MUTATION_TYPES.FETCH_FEEDBACK_FORM_LOADING](state: TFeedbackStore, payload: boolean): void {
    state.period.questionsLoading = payload;
  },
  [MUTATION_TYPES.UPDATE_QUESTIONS](state: TFeedbackStore, payload: TFeedbackQuestion[]): void {
    if (payload?.length) {
      state.questions = payload;
      state.totalStep = payload.findIndex((item) => !item.next) + 1;
      state.questionActive = payload[0];
      state.firstQuestionActive = payload[0];
    }
  },
  [MUTATION_TYPES.SET_FEEDBACK_FROM](state: TFeedbackStore, payload: TFeedbackForm): void {
    state.feedbackForm[payload.handle] = payload;
    state.feedbackFormActive = payload;
    state.initStore = _cloneDeep(state);
  },
  [MUTATION_TYPES.UPDATE_QUESTION_ACTIVE](state: TFeedbackStore, payload: TFeedbackQuestion): void {
    state.questionActive = payload;
  },
  [MUTATION_TYPES.UPDATE_RESULT](state: TFeedbackStore, payload: TResult) {
    state.results[payload.questionId] = payload;
  },
  [MUTATION_TYPES.CLEAR_STORE](state: TFeedbackStore) {
    const newStoreCreated = _cloneDeep(state.initStore);
    if (newStoreCreated) {
      state.period = newStoreCreated.period;
      state.questionActive = newStoreCreated.questionActive;
      state.questions = newStoreCreated.questions;
      state.results = newStoreCreated.results;
    }
  },
  [MUTATION_TYPES.UPDATE_SUBMIT_LOADING](state: TFeedbackStore, payload: boolean) {
    state.period.submitLoading = payload;
  },
};
